import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, SelectPicker, toaster, Notification } from "rsuite";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	getSKUSubstituionTableData,
	getSKUTaxonomy,
	updateSKUSubstitutionTableData,
} from "../../queries/apiQueries";
import "./skuManagement.scss";
import ProductTaxonomy from "./productTaxonomy";
import SkuSubstitutionTable from "./skuSubstitutionTable";
import { appInsights } from "../router";
import { numberFormatter, TIMELINE } from "../../utils";
import MainHeader from "../../components/Layouts/MainHeader";
import ToggleSwitch from "../../components/common/ToggleSwitch";
import MainContent from "../../components/Layouts/MainContent";
import TableTitle from "../../components/common/Table/TableTitle";
import { Segmented } from "antd";
import { Loader } from "../../components/common/Loader";
import { getTimelineOptions } from "../../config/constants";

const SkuManagement = (props: any) => {
	const dispatch = useDispatch<any>();
const timelineOptions=getTimelineOptions()
	const [skuTableData, setSkuTableData] = useState<any>(null);
	const [skuTableCount, setSkuTableCount] = useState<any>(null);
	const [skuCount, setSkuCount] = useState<any>(null);
	const [skuOpportunity, setSkuOpportunity] = useState<any>(null);
	const [pageNumber, setPageNumber] = useState(1);
	const [SKUExportData, setSKUExportData] = useState<any>([]);
	const [tempPageNumber, setTempPageNumber] = useState(null);
	const [tempSelectedCategory, setTempSelectedCategory] = useState(null);
	const [ExportFlag, setExportFlag] = useState(false);
	const [alert, setAlert] = useState(false);
	const [page, setPage] = useState("tree");
	const [leanageValue, setLeanageValue] = useState<any>([]);
	const [relevantAttributes, setRelevantAttributes] = useState<any>([]);
	const [selectedAttributeAndTaxanomy, setSelectedAttributeAndTaxanomy] =
		useState([]);
	const [attributeLength, setAttributeLength] = useState<any>(0);

	const [isLoading, setIsLoading] = useState(true);

	const [errorMessage, setErrorMessage] = useState("");
	const [isVisible, setIsVisible] = useState(false);

	const emptyPayload = {
		l1: [],
		l2: [],
		l3: [],
		l4: [],
		lnumber: 0,
	};

	const timeline = useSelector((state: any) => state.CommonReducer.timeline);

	const [tree, updateTree] = useState<Array<any>>([]);

	const [selectedCategory, setSelectedCategory] = useState<any>({
		l1: [],
		l2: [],
		l3: [],
		l4: [],
		l5: [],
		l6: [],
		l7: [],
		l8: [],
		l9: [],
		l10: [],

		lnumber: 0,
		Type: [],
		Material: [],
		Finish: [],
		Configuration: [],
		Throat_Type: [],
		Trade_Size_Class: [],
		GFCI_Tamper_Weather_Resistant: [],
		GFCI_Self_Test: [],
		No_of_Wires: [],
		No_of_Poles: [],
		Voltage_Rating: [],
		Amperage_Rating: [],
		Color: [],
		Cable_Type: [],
		Cable_Category: [],
		Flammability_Rating: [],
		Gauge: [],
		Jacket_Material: [],
		No_Of_Pairs: [],
		Shield: [],
		Connector_Configurations: [],
		Connector_Type: [],
		Fiber_Category: [],
		Fiber_Cord_Type: [],
		Fiber_Count: [],
		Jacket_Color: [],
		No_Of_Connectors: [],
	});
	const [isRightVisible, setIsRightVisible] = useState(false);

	const [tableLoading, setTableLoading] = useState(true);
	const [selectedTimeline, setSelectedTimeline] = useState(
		timeline ? timeline : getTimelineOptions()[0]?.value
	);

	const isPageNumberSelected = useRef<boolean>(false);

	useEffect(() => {
		appInsights.trackPageView({
			name: `Navigate to SKU Management by ${localStorage.getItem(
				"name"
			)}`,
		});
		getSKUTaxonomyData(emptyPayload);
		getSkuTableData({ pageNumber: [0], pageSize: [20], isExport: false });
	}, []);

	useEffect(() => {
		props.onTimelineChange(selectedTimeline);
		// getSkuTableData({ pageNumber: [pageNumber], pageSize: [20] ,isExport : false});
		if (selectedTimeline) {
			// setSelectedCategory(emptyPayload);
			getSKUTaxonomyData(selectedCategory);
			// getSkuTableData({ pageNumber: [pageNumber], pageSize: [20] });
			getSkuTableData({
				...selectedCategory,
				pageNumber: [pageNumber],
				pageSize: [20],
				isExport: false,
			});
		}
	}, [selectedTimeline]);

	useEffect(() => {
		getSkuTableData({
			...selectedCategory,
			pageNumber: [pageNumber],
			pageSize: [20],
			isExport: false,
		});
		if (isPageNumberSelected.current) {
			getSkuTableData({ pageNumber: [pageNumber], pageSize: [20] });
			isPageNumberSelected.current = false;
		}
	}, [pageNumber]);

	// useEffect(() => {
	//   if(skuTableData){
	//     let count = Number(skuTableData[0]?.skuSubstituteCountTotal);
	//     let opportunity = skuTableData[0]?.adjMarginOpportunityTotal;
	//     setSkuCount(count);
	//     setSkuOpportunity(opportunity);
	//     let newTableData= skuTableData.shift();
	//   }
	// }, [skuTableData])

	const getSKUTaxonomyData = async (payload: any) => {
		// setTreeLoading(true);
		// payload = { ...selectedFilters, ...payload };
		payload.timeline = selectedTimeline;
		let res = await dispatch(getSKUTaxonomy(payload));
		if (res?.error) {
			setErrorMessage(res.message);
		} else if (res?.data) {
			setLeanageValue(res?.leneage?.leneageGraph);
			setRelevantAttributes(res?.relevantAttr);
			setErrorMessage("");
			let depth = res.dataKey.substring(1) * 1;
			let tempTree = tree;
			if (tree.length > depth) {
				tempTree = tree.slice(0, depth);
			}

			if (res?.data) {
				res.data.sort((x: any, y: any) => y.spend - x.spend);
			}

			tempTree[depth - 1] = res;
			updateTree([...tempTree]);
			// }
			if (payload.lnumber >= 10 && res.isDataAvailable) {
				setAttributeLength(payload.lnumber + 1 - 10);
			} else if (payload.lnumber < 10) {
				setAttributeLength(0);
			}
		}
		setIsLoading(false);
	};

	const removeLeadingZero = (n: any) => {
		let newStr = n?.replace(/^0+/, "");
		return newStr;
	};

	const getSubstituteOptions = (materials: any) => {
		let options: any = [];
		materials.map((item: any, key: any) => {
			if (item.recommendation === "Do Nothing") {
				options = [...options, removeLeadingZero(item.GBID)];
			}
		});
		const SubstituteOptions = options.map((item: any) => ({
			label: item,
			value: item,
		}));
		return SubstituteOptions;
	};

	const getSkuTableData = async (payload: any) => {
		setTableLoading(true);
		// payload = { ...selectedFilters, ...payload };
		payload.timeline = selectedTimeline;
		let res = await dispatch(getSKUSubstituionTableData(payload));
		if (res?.error) {
			setErrorMessage(res.message);
		} else {
			setErrorMessage("");
			res?.data.map((d: any) => {
				d.save = false;
			});

			let count = Number(res?.data[0]?.skuSubstituteCountTotal);
			let opportunity = res?.data[0]?.adjMarginOpportunityTotal;
			setSkuCount(count);
			setSkuOpportunity(opportunity);
			let newTableData = res?.data;
			newTableData.shift();
			newTableData?.map((item: any) => {
				const temp = getSubstituteOptions(item.materials)[0]?.value;
				item?.materials?.map((i: any) => {
					if (i?.SubstituteToItem) {
						i[`selectedSubstitute`] = removeLeadingZero(
							i.SubstituteToItem
						);
					} else {
						i[`selectedSubstitute`] = temp;
					}
				});
			});
			setSkuTableData(newTableData);

			setSkuTableCount(res?.count);
		}
		setTableLoading(false);
	};

	const handleSave = async (payload: any) => {
		setTableLoading(true);

		payload.timeline = selectedTimeline;

		let res = await dispatch(updateSKUSubstitutionTableData(payload));
		if (res?.error && res?.error !== "None") {
			setErrorMessage(res.message);
		} else {
			setErrorMessage("");
			//  let tableData = skuTableData;
			//  tableData.map((item:any)=>{
			//   if(item.substitueGroup === payload.substitueGroup){
			//     item.save = false;
			//   }
			//  })
			//  setSkuTableData(JSON.parse(JSON.stringify(tableData)));
			getSKUTaxonomyData(selectedCategory);
			// getSkuTableData({ pageNumber: [pageNumber], pageSize: [20] });
			getSkuTableData({
				...selectedCategory,
				pageNumber: [pageNumber],
				pageSize: [20],
				isExport: false,
			});
		}
		setTableLoading(false);
	};

	const handleSKUSelection = (
		itemName: string,
		level: any,
		index: any,
		attributekey: any
	) => {
		setExportFlag(false);
		let obj: any = {};

		for (let i = 1; i <= leanageValue.length; i++) {
			if (level.substring(1) * 1 < i) {
				obj[`l${i}`] = [];
			}
		}
		if (skuTableData?.some((d: any) => d?.save === true)) {
			setAlert(true);
			setTempSelectedCategory({
				...selectedCategory,
				[attributekey]: [itemName],
				[level]: [itemName],
				lnumber: index + 1,
				...obj,
			});
		} else {
			let selectedCatogeryCopy = JSON.parse(
				JSON.stringify(selectedCategory)
			);
			let isMatched = false;
			leanageValue?.forEach((element: any) => {
				if (!isMatched) {
					if (element === attributekey) {
						isMatched = true;
					}
				} else {
					selectedCatogeryCopy[element] = [];
				}
			});
			let temp: any = {};
			if (leanageValue.length > 10) {
				for (let i = 11; i <= leanageValue.length; i++) {
					temp[`l${i}`] = [];
				}
			}

			let selectedAttributeAndTaxanomyCopy = JSON.parse(
				JSON.stringify(selectedAttributeAndTaxanomy)
			);

			selectedAttributeAndTaxanomyCopy =
				selectedAttributeAndTaxanomyCopy.slice(0, index);
			selectedAttributeAndTaxanomyCopy.push(itemName);
			setSelectedAttributeAndTaxanomy(selectedAttributeAndTaxanomyCopy);

			setSelectedCategory({
				...selectedCatogeryCopy,
				[attributekey]: [itemName],
				lnumber: index + 1,
				...obj,
				...temp,
			});
		}
	};

	const handleAlertClose = () => setAlert(false);

	const handleAlertConfirmClick = () => {
		// .save to false
		skuTableData.map((item: any) => {
			item.save = false;
		});
		if (tempPageNumber !== null) {
			setPageNumber(tempPageNumber);
			isPageNumberSelected.current = true;
		}
		if (tempSelectedCategory !== null) {
			setSelectedCategory(tempSelectedCategory);
		}
		setAlert(false);
	};

	const handleActionChange = (
		itemId: any,
		selectedValue: any,
		index: any,
		childIndex: any
	) => {
		let tableData = skuTableData;
		tableData[index].materials[childIndex].recommendation = selectedValue;
		tableData[index].save = true;
		if (selectedValue === "Substitute") {
			let cost: any = 0;
			let substitute: any = null;

			tableData[index].materials.map((item: any, key: any) => {
				if (
					item.recommendation === "Do Nothing" &&
					item.GBID !== itemId
				) {
					if (cost < item.cost) {
						cost = item.cost;
						substitute = item.GBID;
					}
				}
			});

			let opp =
				(tableData[index].materials[childIndex].cost - cost) *
				tableData[index].materials[childIndex].volume;
			tableData[index].materials[childIndex].adjMarginOpportunity =
				opp / 2;
			tableData[index].materials[childIndex].SubstituteToItem =
				substitute;
		} else {
			tableData[index].materials[childIndex].adjMarginOpportunity = 0;
			tableData[index].materials[childIndex].SubstituteToItem = null;
		}
		setSkuTableData(JSON.parse(JSON.stringify(tableData)));
	};

	/* on changing timeline */
	const timelineHandler = (e: any) => {
		setSelectedTimeline(e === null ? "All" : e);
	};

	const handleSubstituteChange = (
		selectedValue: any,
		index: any,
		childIndex: any
	) => {
		let tableData = skuTableData;
		let cost: any = 0;
		let material: any = null;

		tableData[index].materials.map((item: any, key: any) => {
			if (item.recommendation === "Do Nothing") {
				if (
					Number(removeLeadingZero(item.GBID)) ===
					Number(selectedValue)
				) {
					cost = item.cost;
					material = item.GBID;
				}
			}
		});
		let opp =
			(tableData[index].materials[childIndex].cost - cost) *
			tableData[index].materials[childIndex].volume;
		tableData[index].materials[childIndex].adjMarginOpportunity = opp / 2;
		tableData[index].materials[childIndex].SubstituteToItem = material;
		tableData[index].save = true;

		setSkuTableData(JSON.parse(JSON.stringify(tableData)));
	};

	const GetExportData = async (isExport: any) => {
		if (isExport) {
			toaster.push(message, { placement: "topCenter" });
		}
		let res = await dispatch(
			getSKUSubstituionTableData({
				...selectedCategory,
				pageNumber: [0],
				pageSize: [20],
				isExport: isExport,
				timeline: selectedTimeline,
			})
		);
		if (isExport) {
			let newexportData = res?.data;
			newexportData.shift();
			const csvData = newexportData
				.map((item: any, index: any) => {
					const materialRows = item.materials.map(
						(material: any, i: any) => ({
							substitueGroup: material.substitueGroup,
							index: i + 1,
							GBID: material.GBID,
							MANUFACTURER_PART_NO_MFRPN:
								material.MANUFACTURER_PART_NO_MFRPN,
							master_vendor_name: material.master_vendor_name,
							volume: material.volume,
							cost: material.cost,
							Price: material.Price,
							Margin: material.Margin,
							recommendation: material.recommendation,
							SubstituteToItem: material.SubstituteToItem,
							adjMarginOpportunity: material.adjMarginOpportunity,
						})
					);
					return materialRows;
				})
				.flat();
			setExportFlag(true);
			setSKUExportData(csvData);
		}
	};

	useEffect(() => {
		getSKUTaxonomyData(selectedCategory);
		getSkuTableData({
			...selectedCategory,
			pageNumber: [0],
			pageSize: [20],
			isExport: false,
		});
	}, [selectedCategory]);
	const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.checked) {
			setPage("opportunity");
		} else {
			setPage("tree");
		}
	};

	const getHeightOfTable = () => {
		if (page === "tree") {
			if (selectedCategory["l1"].length > 0) {
				return "h-[78.5%]";
			}
			return "h-[90%]";
		} else if (page !== "tree") {
			if (selectedCategory["l1"].length > 0) {
				return "h-[75.5%]";
			}
			return "h-[75%]";
		}
	};

	return isLoading ? (
		<Loader />
	) : (
		<>
			<div className="skuManagement-container w-full">
				<Modal
					backdrop={true}
					role="alertdialog"
					open={alert}
					onClose={handleAlertClose}
					size="xs"
				>
					<Modal.Body>
						You have some unsaved changes. Are you sure, you want to
						continue without saving?
					</Modal.Body>
					<Modal.Footer>
						<Button
							onClick={handleAlertConfirmClick}
							className="modal-yes-btn"
						>
							Yes, Continue
						</Button>
						<Button
							onClick={handleAlertClose}
							className="modal-close-btn"
						>
							Close
						</Button>
					</Modal.Footer>
				</Modal>

				<MainHeader
					onVisibilityChange={setIsVisible}
					isRightVisible={isRightVisible}
					setIsRightVisible={setIsRightVisible}
					topContent={
						<>
							<div className="flex justify-between items-center w-full">
								<div className="text-left pageline">
									<span className="pagelinestart">
										Assortment and Product
									</span>{" "}
									<span className="pagelineslash">/</span>{" "}
									<span className="pagelinesub">
										SKU Management
									</span>
								</div>
							</div>

							<div className="execution-level-wrapper">
								<div className="execution-level-title">
									View By
								</div>
								<Segmented
									options={[
										{
											label: "Variant Tree",
											value: "tree",
										},
										{
											label: "Opportunity",
											value: "opportunity",
										},
									]}
									value={page}
									onChange={(value) => setPage(value)}
								/>
							</div>
						</>
					}
					bottomContent={
						<div className="sub-heading-text font-bold flex flex-col items-start">
							<span className="filterHead ">Timeline</span>
							<SelectPicker
								data={
									timelineOptions.length
										? timelineOptions
										: []
								}
								placeholder="All"
								value={selectedTimeline}
								
								defaultValue={
									timelineOptions.length
										? timelineOptions[0].value
										: ""
								}
								onChange={timelineHandler}
								cleanable={false}
							/>
						</div>
					}
				/>
				<MainContent isVisible={isVisible} fullHeight={true}>
					<>
						{page === "tree" && (
							<div className="flex flex-col items-center w-full">
								<div className="flex  gap-5 w-full mb-2">
									{/* SKUs to Substitute Card */}
									<div
										className="infocard cursor-pointer max-w-[20vw]"
										onClick={() => setPage("opportunity")}
									>
										<div className="infocardHead">
											<span className="headerText">
												SKUs to Substitute
											</span>
										</div>
										<div className="contentText">
											{skuCount}
										</div>
									</div>
									{/* Opportunity Card */}
									<div
										className="infocard cursor-pointer max-w-[20vw]"
										onClick={() => setPage("opportunity")}
									>
										<div className="infocardHead">
											<span className="headerText">
												Opportunity
											</span>
										</div>
										<div className="contentText">
											{numberFormatter(
												skuOpportunity,
												1,
												"$"
											)}
										</div>
									</div>
								</div>
							</div>
						)}

						<div
							className={`contentBox !py-0 ${
								page === "tree" ? "h-[88%]" : "h-[100%]"
							}`}
						>
							{page != "tree" && (
								<div>
									<div className="flex">
										<div className="w-[52%] pr-[0.2vw]">
											<div className="headSpace">
												<div className="headContent">
													Taxonomy
												</div>
											</div>
										</div>
										<div className="w-[64%] pl-[0.2vw]">
											<div className="headSpace">
												<div className="headContent">
													Attributes
												</div>
											</div>
										</div>
									</div>
									<div
										className={`flex gap-x-[0.4vw] pl-[0.4vw] overflow-auto  ${
											selectedAttributeAndTaxanomy?.length >
											0
												? "mt-2"
												: ""
										}`}
									>
										{selectedAttributeAndTaxanomy.map(
											(item: any, k: any) => {
												return (
													<div
														className={`nav-items h-[6vh] min-w-[10vw] flex justify-center items-center ${
															k < 4
																? "bg-[#eeF9ff] border-[0.5px] border-[#62b5e5]"
																: "bg-[#f9ffed] border-[0.5px] border-[#86BC25]"
														} text-black w-[7.6vw] text-center rounded-sm overflow-y-auto py-1 px-1`}
													>
														<span className="font-[400] textSmall">
															{item}
														</span>
													</div>
												);
												// }
											}
										)}
									</div>
								</div>
							)}

							{page === "tree" ? (
								<div className={`chart-flex ${selectedAttributeAndTaxanomy?.length >
												0?'h-[100%]':'h-[95%]'} `}>
									<div
										className="taxonomy-container"
										style={{
											border: 0,
											padding: 0,
											width: "100%",
										}}
									>
										<div className="flex">
											<div className="w-[52%] pr-[0.2vw]">
												<div className="headSpace">
													<div className="headContent">
														Taxanomy
													</div>
												</div>
											</div>
											<div className="w-[64%] pl-[0.2vw]">
												<div className="headSpace">
													<div className="headContent">
														Attributes
													</div>
												</div>
											</div>
										</div>
										<div
											className={`flex gap-x-[0.4vw] pl-[0.4vw]  overflow-auto ${
												selectedAttributeAndTaxanomy?.length >
												0
													? "mt-2"
													: ""
											}`}
										>
											{selectedAttributeAndTaxanomy.map(
												(item: any, k: any) => {
													return (
														<div
															key={k}
															className={`nav-items h-[6vh] min-w-[10vw] flex justify-center items-center shadow-md ${
																k < 4
																	? "bg-[#eeF9ff] border-[0.5px] border-[#62b5e5]"
																	: "bg-[#f9ffed] border-[0.5px] border-[#86BC25]"
															} text-black w-[7.6vw] text-center rounded-sm overflow-y-auto py-1 px-1`}
														>
															<span className="font-[400] textSmall">
																{item}
															</span>
														</div>
													);
													// }
												}
											)}
										</div>
										{errorMessage?.length > 0 ? (
											<div className="flex justify-center items-center h-full text-mainGreen">
												{errorMessage}
											</div>
										) : (
											<div
												className={`overflow-auto ${
													selectedAttributeAndTaxanomy?.length >
													0
														? "h-[73%] max-h-[73%]"
														: "h-[90%] max-h-[90%]"
												} flex flex-col items-start border-[0.5px] border-lightGrey mt-[0.7vw] bg-white shadow-md`}
											>
												<ProductTaxonomy
													skuTree={tree}
													selection={selectedCategory}
													handleClick={
														handleSKUSelection
													}
													leanageValue={leanageValue}
													relevantAttributes={
														relevantAttributes
													}
												/>
											</div>
										)}
										<div className="text-[#666666] italic textNormal">
											*Note: "SKU Substitution
											opportunities are identified only
											for Non-Project and Stock spend"
										</div>
									</div>
									{/* <div
									className={`w-[6%] h-[98%] flex flex-col justify-between gap-y-[1vh]`}
								>
									<div
										className="sku-container bg-[white] text-black text-center flex flex-col items-start justify-between relative h-[50%] p-[0.5vw] cursor-pointer"
										onClick={() => {
											setPage("opportunity");
										}}
									>
										<span className="font-bold text-left fontNormal">
											SKUs to Substitute
										</span>
										<span className="font-bold text-black text-[1vw] text-left">
											{skuCount}
										</span>
									</div>
									<div
										className="sku-container bg-[white] text-black text-center flex flex-col justify-between relative h-[50%] p-[0.5vw] cursor-pointer"
										onClick={() => {
											setPage("opportunity");
										}}
									>
										<span className="font-bold text-left fontNormal">
											Opportunity
										</span>
										<span className="font-bold text-black text-[1vw] text-left">
											{numberFormatter(
												skuOpportunity,
												1,
												"$"
											)}
										</span>
									</div>
								</div> */}
								</div>
							) : (
								<div
									className={`chart-flex w-[100%] ${
										isVisible ? "h-[68%]" : "h-[72%]"
									}`}
								>
									<div className="taxonomy-container w-[100%]">
										{tableLoading ? (
											<Loader />
										) : errorMessage.length > 0 ? (
											<div className="flex justify-center items-center h-full text-mainGreen">
												{errorMessage}
											</div>
										) : (
											<SkuSubstitutionTable
												data={skuTableData}
												count={skuTableCount}
												pageNumber={pageNumber}
												SKUExportData={SKUExportData}
												GetExportData={() =>
													GetExportData(true)
												}
												ExportFlag={ExportFlag}
												updatePageNumber={(
													page: any
												) => {
													if (
														skuTableData.some(
															(d: any) =>
																d.save === true
														)
													) {
														setAlert(true);
														setTempPageNumber(page);
													} else {
														setPageNumber(page);
														isPageNumberSelected.current =
															true;
													}
												}}
												updateActionChange={(
													itemId: any,
													selectedValue: any,
													index: any,
													childIndex: any
												) => {
													handleActionChange(
														itemId,
														selectedValue,
														index,
														childIndex
													);
												}}
												updateSubstituteChange={(
													selectedValue: any,
													index: any,
													childIndex: any
												) => {
													handleSubstituteChange(
														selectedValue,
														index,
														childIndex
													);
												}}
												updateSelectedSubtitute={(
													selectedValue: any,
													index: any,
													childIndex: any
												) => {
													let tableData =
														skuTableData;
													tableData[index].materials[
														childIndex
													].selectedSubstitute =
														selectedValue;
													setSkuTableData(
														JSON.parse(
															JSON.stringify(
																tableData
															)
														)
													);
												}}
												getDefaultSubstituteSelection={() => {
													let tableData =
														skuTableData;
													tableData.map(
														(item: any) => {
															const temp =
																getSubstituteOptions(
																	item.materials
																)[0].value;
															item.materials.map(
																(i: any) => {
																	i[
																		`selectedSubstitute`
																	] = temp;
																}
															);
														}
													);
													setSkuTableData(
														JSON.parse(
															JSON.stringify(
																tableData
															)
														)
													);
												}}
												handleSaveButtonClick={(
													selectedObject: any
												) => {
													handleSave(selectedObject);
												}}
											/>
										)}
									</div>
								</div>
							)}
						</div>
					</>
				</MainContent>
			</div>
		</>
	);
};
const message = (
	<Notification type={"info"} header={`Exporting...`} closable>
		<p>Your file is being created. It will be download automatically</p>
	</Notification>
);

const mapDispatchToProps = (dispatch: any) => ({
	onTimelineChange: (data: any) => dispatch({ type: TIMELINE, data: data }),
});

// export default SkuManagement;
export default connect(null, mapDispatchToProps)(SkuManagement);
